import { LinkDataType } from "../../components/DMAutomation/AddLink";
import { apiConfigs } from "../../constants/apiConfigs"
import { DMAutomationItem, DMAutomationsData } from "../../types/automations/dmAutomationTypes";
import axiosClient from "../../utils/axiosClient"

export const fetchDMAutomations = async (social_account_id: string, page: number = 1): Promise<DMAutomationsData> => {
    const response = await axiosClient.get(apiConfigs.FETCH_DM_AUTOMATIONS.url, { params: { social_account_id, page, limit: 20 } });
    return response.data;
}

export const fetchDMAutomation = async (postId: string): Promise<DMAutomationItem> => {
    const response = await axiosClient.get(apiConfigs.FETCH_DM_AUTOMATION.url.replace('<postId>', postId));
    return response.data;
}

export const createDMAutomation = async (data: LinkDataType) => {
    const response = await axiosClient.post(apiConfigs.CREATE_DM_AUTOMATION.url, data)
    return response.data;
}

export const updateDMAutomation = async (postId: string, data: any) => {
    const response = await axiosClient.put(apiConfigs.UPDATE_DM_AUTOMATION.url.replace('<postId>', postId), data)
    return response.data;
}

export const deleteDMAutomation = async (postId: string) => {
    const response = await axiosClient.delete(apiConfigs.DELETE_DM_AUTOMATION.url.replace('<postId>', postId))
    return response.data;
}

export const fetchAvailablePosts = async (social_account_id: string) => {
    const response = await axiosClient.get(apiConfigs.AVAILABLE_POSTS_DM_AUTOMATION.url, { params: { social_account_id } });
    return response.data.items ?? [];
}